import { render, staticRenderFns } from "./ServiceList.vue?vue&type=template&id=60435914&scoped=true"
import script from "./ServiceList.vue?vue&type=script&lang=js"
export * from "./ServiceList.vue?vue&type=script&lang=js"
import style0 from "./ServiceList.vue?vue&type=style&index=0&id=60435914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60435914",
  null
  
)

export default component.exports